'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_IngredientComponent$State(stateSnapshot, unitOptions, groceryItemSearchOptions) {
  this.sP = null;
  this.Dd = null;
  this.zo = null;
  this.sP = stateSnapshot;
  this.Dd = unitOptions;
  this.zo = groceryItemSearchOptions;
}
export { $c_Lmealorama_components_IngredientComponent$State as $c_Lmealorama_components_IngredientComponent$State };
$p = $c_Lmealorama_components_IngredientComponent$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_IngredientComponent$State;
/** @constructor */
function $h_Lmealorama_components_IngredientComponent$State() {
}
export { $h_Lmealorama_components_IngredientComponent$State as $h_Lmealorama_components_IngredientComponent$State };
$h_Lmealorama_components_IngredientComponent$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 382765188, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_IngredientComponent$State)) {
    var x = this.sP;
    var x$2 = x$0.sP;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.Dd;
      var x$4 = x$0.Dd;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.zo;
      var x$6 = x$0.zo;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 3;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sP;
      break;
    }
    case 1: {
      return this.Dd;
      break;
    }
    case 2: {
      return this.zo;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_IngredientComponent$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k9)));
}
export { $isArrayOf_Lmealorama_components_IngredientComponent$State as $isArrayOf_Lmealorama_components_IngredientComponent$State };
var $d_Lmealorama_components_IngredientComponent$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_IngredientComponent$State, "mealorama.components.IngredientComponent$State", ({
  k9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_IngredientComponent$State as $d_Lmealorama_components_IngredientComponent$State };
//# sourceMappingURL=mealorama.components.-Ingredient-Component$-State.js.map
